import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { QuickAddService } from '../../services/quick-add.service';
 
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TaskViewModel } from '../../models-views/task.view.model';
import { ProjectViewModel } from '../../models-views/project.view.model';
import { AppCommon } from '../../providers/app-common';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DatePipe } from '@angular/common';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { debounceTime, distinctUntilChanged, from, fromEvent, Observable, Observer, of, Subject, switchMap, takeUntil } from 'rxjs';
import { QuillCustomServices } from '../../providers/quill-config';
import { Router } from '@angular/router';

@Component({
  selector: 'app-project-drawer',
  standalone: false,
  templateUrl: './project-drawer.component.html',
  styleUrl: './project-drawer.component.scss',
  providers: [DatePipe] 
})
export class ProjectDrawerComponent {
  loggedInUser :any
  projectForm: FormGroup;
  quillConfig :any;
  page = 1;
  page_size = 10;
  dateFormat = 'yyyy-MM-dd'; // Display format
  allUsers: any[] = []
  listOfUser=[]
  listOfCsmUser=[]
  listOfClient=[]
  regionList:any = []
  // cityList:any = []
  contactTypeList = []
  projectFormatList: any[] = []
  projectFormatTypeList: any[] = []
  listOfUserGroup=[]
  projectStatusList= []
  fileList: NzUploadFile[] = []
  scfileList: NzUploadFile[] = []
  @Input() isVisible = false;
  @Input() data:any;
  @Output() closeDrawer = new EventEmitter<boolean>();
  private destroy$ = new Subject<boolean>();
  readonly nzFilterOption = (): boolean => true;
  searchInput$ = new Subject<string>();
  isVisibleAddLink:boolean
  projectLinks:any[] = []
  loadingClient:boolean = false
  disabledClient = false
  closedCancelledReason:any= []
  projectList:any[] = []
  userSearchTimeOut:any
  csmSearchTimeOut:any
  regionSearchTimeOut:any
  cityClearTimeOut:any
  private readonly CSM_GROUP_NAME = 'customer ops';
  constructor(private fb: FormBuilder , private quickAddService: QuickAddService,private datePipe: DatePipe,private router: Router,
    private vm :ProjectViewModel, private vmt : TaskViewModel,private message: NzMessageService,private quilservice:QuillCustomServices) {
      this.vm.projectDrawerComponent = this
     this.loggedInUser = AppCommon.getloggedInObject().user
    this.InitForm()
    this.vmt.userGroupList.subscribe( e => this.listOfUserGroup = e.results )
    this.vm.userListP.subscribe((e: any) => {
      this.allUsers = e?.results || [];
      this.applyAssignToFilter();
      this.applyCsmFilter();
    })
    this.vm.projectContactTypeList.subscribe( e => this.contactTypeList = e.results )
    this.vm.projectStatusList.subscribe( e => this.projectStatusList = e.results )
    this.vm.projectFormatList.subscribe( e => {
      this.projectFormatList = e.results;
      // Load format types for the currently selected format
      const currentFormatId = this.projectForm.get('project_format')?.value;
      if (currentFormatId != null) {
        this.loadProjectFormatTypesById(currentFormatId);
      }
    })
    this.vm.projectFormatTypeList.subscribe( e => this.projectFormatTypeList = e.results )
    this.vm.clientList.subscribe( e =>( this.listOfClient = e.results, this.loadingClient = false) )
    this.vm.projectClosedCancelledReason.subscribe( e => this.closedCancelledReason = e.results)
    this.vm.projectListData.subscribe( e => this.projectList = e.results)
    this.vm.regionList.subscribe( e => this.regionList = e.results )
    // this.vm.cityList.subscribe( e => this.cityList = e.results )
    this.quillConfig = this.quilservice.QuillConfigDefault 
    this.vmt.userList.pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
            this.quilservice.setMentions(data.results)  
    })
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.vmt.getUserGroupList(this.page,this.page_size)
    // this.vmt.getUserList(this.page,this.page_size)
    this.vm.getProjectContactTypeList(this.page,this.page_size)
    this.vm.getProjectFormatList()
    this.vm.getProjectClosedCancelledReasonList(this.page,this.page_size)
    this.vm.getProjectStuatusList(this.page,this.page_size)
    this.vm.getClientList(this.page,500)
    this.vm.getRegionList();
    this.vm.getProjectList(this.page, this.page_size, '', 'add projects', {});
    // Load users once and filter locally for Assign To and CSM dropdowns.
    this.vm.getUserList(1, 500);
    this.searchInput$.pipe(debounceTime(500),distinctUntilChanged()).subscribe( name => this.vm.getClientList(this.page,this.page_size,name))

    // When project_format changes, reload filtered format types
    this.projectForm.get('project_format')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((formatId: number) => {
        this.projectForm.get('project_format_type')?.setValue(null, { emitEvent: false });
        if (formatId != null) {
          this.loadProjectFormatTypesById(formatId);
        } else {
          this.projectFormatTypeList = [];
        }
      });

    // Fetch users when assigned_to_group changes (pass comma-separated group IDs)
    this.projectForm.get('assigned_to_group')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((groups: number[]) => {
        if (Array.isArray(groups) && groups.length > 0) {
          this.applyAssignToFilter();
        } else {
          // Clear users if no group selected
          this.listOfUser = [];
          this.projectForm.get('assign_to')?.setValue([], { emitEvent: false });
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(this.data && changes['data'].currentValue){

      // console.log(changes['data'].currentValue)
      let FormData = {
        project_client: changes['data'].currentValue?.project_client,
        name:changes['data'].currentValue?.name,
        description: changes['data'].currentValue?.description,
        total_events: changes['data'].currentValue?.total_events ?? 0,
        project_cost: changes['data'].currentValue?.project_cost,
        due_date: changes['data'].currentValue?.due_date,
        contact_type: changes['data'].currentValue?.contact_type,
        signup_date: changes['data'].currentValue?.signup_date || '',
        is_global_region: changes['data'].currentValue?.is_global_region ?? false,
        regions: this.normalizeRegions(changes['data'].currentValue),
        city: changes['data'].currentValue?.city || '',
        assign_to:changes['data'].currentValue?.assign_to,
        assigned_to_group: changes['data'].currentValue?.assigned_to_group,
        project_format: changes['data'].currentValue?.project_format ?? null,
        project_format_type: changes['data'].currentValue?.project_format_type ?? null,
        customer_success_manager: changes['data'].currentValue?.customer_success_manager,
        status: changes['data'].currentValue?.status,
        contract_files:changes['data'].currentValue?.contract_files,
        additional_files: changes['data'].currentValue?.additional_files,
        links: changes['data'].currentValue?.links,
        cancelled_closed_reason_str: changes['data'].currentValue?.cancelled_closed_reason_str,
        closed_reason: changes['data'].currentValue?.closed_reason,
        cancelled_reason: changes['data'].currentValue?.cancelled_reason,
        previous_project: null,
      }
      this.projectForm.patchValue(FormData)
      // Load format types for the patched format
      if (FormData.project_format != null) {
        this.loadProjectFormatTypesById(FormData.project_format);
      }
      this.updateRegionControlState(this.projectForm.get('is_global_region')?.value)
      this.projectForm.get('signup_date')?.disable();
      // this.projectForm.get('city')?.disable();
     
      changes['data'].currentValue?.contract_file_details &&  (this.scfileList  = changes['data'].currentValue.contract_file_details.map(file => ({
        uid: file.id,
        name: file.name,
        status: 'done',
        url: file.file
      })));
      changes['data'].currentValue?.additional_file_details && (  this.fileList= changes['data'].currentValue.additional_file_details.map(file => ({
        uid: file.id,
        name: file.name,
        status: 'done',
        url: file.file
      })));
      this.disabledClient = true
      
      // Ensure the city is in the list for display
      // if (changes['data'].currentValue?.city_details) {
      //   const cityDetails = changes['data'].currentValue.city_details;
      //   // Check if city is already in the list to avoid duplicates
      //   const exists = this.cityList.some((c: any) => c.id === cityDetails.id);
      //   if (!exists) {
      //     const formattedCity = {
      //       ...cityDetails,
      //       state_name: cityDetails.state,
      //       country_name: cityDetails.country
      //     };
      //     this.cityList = [...this.cityList, formattedCity];
      //   }
      // }
    }
   
  }

  search(value:any){
    this.loadingClient = true
    this.searchInput$.next(value.trim());
  }

  InitForm(){
    this.projectForm = this.fb.group({
      project_client: [sessionStorage.getItem('selectedClient') ? Number(sessionStorage.getItem('selectedClient')) : null , Validators.required],
      name: ['', Validators.required],
      description: ['', Validators.required],
      total_events: [null, [Validators.required, Validators.min(0)]],
      project_cost: ['', Validators.required],
      due_date: ['', Validators.required],
      contact_type: ['', Validators.required],
      signup_date: ['', Validators.required],
      is_global_region: [false, Validators.required],
      regions: [[], Validators.required],
      // city: [null],
      assign_to: [[]],
      assigned_to_group: [[], Validators.required],
      project_format: [null, Validators.required],
      project_format_type: [null, Validators.required],
      customer_success_manager: [''],
      cancelled_closed_reason_str: [''],
      closed_reason: [null ],
      cancelled_reason: [null ],
      previous_project: [null],
      status: [''],
      contract_files: [[]],
      additional_files: [[]],
      links: [[]],
    });

    this.projectForm.get('is_global_region')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((isGlobal: boolean) => this.updateRegionControlState(isGlobal));

    this.updateRegionControlState(this.projectForm.get('is_global_region')?.value);

  }

  private updateRegionControlState(isGlobal: boolean): void {
    const regionsControl = this.projectForm.get('regions');
    if (!regionsControl) {
      return;
    }

    if (isGlobal) {
      regionsControl.clearValidators();
      regionsControl.setValue([], { emitEvent: false });
    } else {
      regionsControl.setValidators([Validators.required]);
    }

    regionsControl.updateValueAndValidity({ emitEvent: false });
  }

  private normalizeRegions(project: any): any[] {
    const regionDetails = Array.isArray(project?.region_details)
      ? project.region_details
      : project?.region_details
      ? [project.region_details]
      : [];

    const regionsFromDetails = regionDetails
      .map((region: any) => region?.id)
      .filter((id: any) => id !== null && id !== undefined);

    if (regionsFromDetails.length > 0) {
      return regionsFromDetails;
    }

    if (Array.isArray(project?.regions)) {
      return project.regions.filter((id: any) => id !== null && id !== undefined);
    }

    if (Array.isArray(project?.region)) {
      return project.region.filter((id: any) => id !== null && id !== undefined);
    }

    if (project?.regions !== null && project?.regions !== undefined && project?.regions !== '') {
      return [project.regions];
    }

    if (project?.region !== null && project?.region !== undefined && project?.region !== '') {
      return [project.region];
    }

    if (project?.region_id !== null && project?.region_id !== undefined) {
      return [project.region_id];
    }

    return [];
  }

  private loadProjectFormatTypesById(formatId: number): void {
    const fmt = Array.isArray(this.projectFormatList)
      ? this.projectFormatList.find((f: any) => f?.id === formatId)
      : undefined;
    const name: string = (fmt?.name || '').toLowerCase();
    let isInPerson = name.includes('in') && name.includes('person');
    let isVirtual = name.includes('virtual');

    const opts: { is_inperson?: boolean; is_virtual?: boolean } = {};
    if (!fmt || (!isInPerson && !isVirtual)) {
      if (formatId === 1) { isInPerson = true; }
      else if (formatId === 2) { isVirtual = true; }
    }
    if (isInPerson) { opts.is_inperson = true; }
    else if (isVirtual) { opts.is_virtual = true; }

    this.vm.getProjectFormatTypeList(1, 500, opts);
  }

  onSearchMember(e:any){
    clearTimeout(this.userSearchTimeOut)
    this.userSearchTimeOut = setTimeout(() => {
      const name = (e || '').trim();
      this.applyAssignToFilter(name);
      } , 400 )
  }

  onAssignToDropdownChange(isOpen: boolean) {
    if (isOpen) {
      this.applyAssignToFilter();
    }
  }

  onSearchCSM(e:any){
    clearTimeout(this.csmSearchTimeOut)
    this.csmSearchTimeOut = setTimeout(() => {
      this.applyCsmFilter((e || '').trim());
      } , 400 )
  }

  private applyAssignToFilter(searchText: string = ''): void {
    const groups: number[] = this.projectForm.get('assigned_to_group')?.value || [];
    if (!Array.isArray(groups) || groups.length === 0) {
      this.listOfUser = [];
      return;
    }

    const term = searchText.toLowerCase();
    this.listOfUser = this.allUsers.filter((user: any) => {
      const userGroups = Array.isArray(user?.user_group) ? user.user_group : [];
      const belongsToSelectedGroup = userGroups.some((group: any) => groups.includes(group?.id));
      const matchesSearch = !term || (user?.name || '').toLowerCase().includes(term);
      return belongsToSelectedGroup && matchesSearch;
    });

    // Keep selected assignees valid when groups are changed.
    const validUserIds = new Set(this.listOfUser.map((u: any) => u.id));
    const selectedAssignees: number[] = this.projectForm.get('assign_to')?.value || [];
    const filteredAssignees = selectedAssignees.filter((id: number) => validUserIds.has(id));
    if (filteredAssignees.length !== selectedAssignees.length) {
      this.projectForm.get('assign_to')?.setValue(filteredAssignees, { emitEvent: false });
    }
  }

  private applyCsmFilter(searchText: string = ''): void {
    const term = searchText.toLowerCase();
    this.listOfCsmUser = this.allUsers.filter((user: any) => {
      const userGroups = Array.isArray(user?.user_group) ? user.user_group : [];
      const isCustomerOps = userGroups.some((group: any) =>
        (group?.name || '').toLowerCase().trim() === this.CSM_GROUP_NAME
      );
      const matchesSearch = !term || (user?.name || '').toLowerCase().includes(term);
      return isCustomerOps && matchesSearch;
    });
  }

  // onSearchCity(e:any){
  //   clearTimeout(this.cityClearTimeOut)
  //   this.cityClearTimeOut = setTimeout(() => {
  //     if(e.length > 0){
  //       this.vm.getCityListById(1,500,null,e)
  //     }
  //   } , 400 )
  // }

  onSearchRegion(value: string) {
    clearTimeout(this.regionSearchTimeOut)
    this.regionSearchTimeOut = setTimeout(() => {
      this.vm.getRegionList((value || '').trim())
    }, 400)
  }

  // onCitySelect(cityId: any) {
  //   // console.log('Selected city ID:', cityId);
  //   const selectedCity = this.cityList.find(city => city.id === cityId);
  //   if (selectedCity) {
  //     // console.log('Selected city details:', selectedCity);
  //   }
  // }

  projectTimeout:any
  searchProject(e:any){
    clearTimeout(this.projectTimeout)
     this.projectTimeout =  setTimeout(()=> {
    if(e.length > 3){
       this.vm.getProjectList(this.page, this.page_size, e, 'add projects', {});
    } else{
      this.vm.getProjectList(this.page, this.page_size, '', 'add projects', {});
    }
    }, 500)
    
  }

   
  
  customUploadRequest = (item: any) => {
    return  this.vmt.uploadMediaFile(item, this.loggedInUser.id)
  }
 
   onUploadContractChange(event: any): void {
    //  console.log('Upload Event:', event);
     if (event.type === 'success') {
      //  console.log('File uploaded successfully:', event.file);
       this.projectForm.get('contract_files')?.setValue([...this.projectForm.get('contract_files').value , event.file.response.id] , { emitEvent: false });
     } else if (event.type === 'error') {
      //  console.error('File upload failed:', event.file);
     } else if(event.type == 'removed'){
      this.scfileList = this.scfileList.filter(f => f.uid !== event.file.uid);
      this.projectForm.get('contract_files')?.setValue([...this.scfileList.map(f => f.uid)] , { emitEvent: false });
     }
  
   }
 

   onUploadAdditionalChange(event: any): void {
    // console.log('Upload Event:', event);
    if (event.type === 'success') {
      this.projectForm.get('additional_files')?.setValue( [ ...this.projectForm.get('additional_files').value ,event.file.response.id], { emitEvent: false });
      // console.log('File uploaded successfully:', event.file);
    } else if (event.type === 'error') {
      // console.error('File upload failed:', event.file);
    } else if(event.type == 'removed'){ 
      this.fileList = this.fileList.filter(f => f.uid !== event.file.uid);
      this.projectForm.get('additional_files')?.setValue( [ ...this.fileList.map(f => f.uid)], { emitEvent: false });
    }
    
  }

   

  

  close(e:any): void {
    this.isVisible = false;
    this.closeDrawer.emit(false);
    // setTimeout(()=> (this.quickAddService.updateQuickAdd('projectclosed')) , 500) 
    this.quickAddService.refreshData.next(true);
    this.projectForm.reset();

    setTimeout(() => {
      this.router.navigate(['app/projects' , e.id])
    },1000)
  }

  closeonly(){
    this.isVisible = false;
    this.closeDrawer.emit(false);
    this.projectForm.reset();
  }

  onSubmit(): void {
    if (this.projectForm.valid) {
      // console.log('Form Submitted:', this.projectForm.value);
      let formData = this.projectForm.value
      formData.total_events = Number(formData.total_events ?? 0)
      formData.is_global_region = !!formData.is_global_region
      formData.regions = Array.isArray(formData.regions)
        ? formData.regions
        : (formData.regions !== null && formData.regions !== undefined && formData.regions !== '' ? [formData.regions] : [])

      if (formData.is_global_region) {
        formData.regions = []
      }
      
      formData.due_date = this.datePipe.transform(formData.due_date, this.dateFormat)
      formData.start_date = this.datePipe.transform(formData.start_date, this.dateFormat)
      formData.signup_date = this.datePipe.transform(formData.signup_date, this.dateFormat)
      this.data ? formData['modified_by'] = this.loggedInUser.id  :  formData['created_by'] = this.loggedInUser.id
      this.data ? this.vm.updateProject(formData, this.data.id, 'app-project-drawer')  :  this.vm.createProject(formData)
    }  else {
      this.message.error('Please fill all required fields correctly');
      Object.values(this.projectForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> => 
    new Observable((observer: Observer<boolean>) => {
        const isLt5M = file.size! / 1024 / 1024 < 5;
        if (!isLt5M) {
            this.message.error(`${file.name} is larger than 5MB!`);
            observer.next(false); // Emit false to indicate validation failed
            observer.complete();
        } else {
            observer.next(true); // Emit true to indicate validation passed
            observer.complete();
        }
    });
    

}
